import { OCDocumentFactory } from './OCDocumentFactory';
import { hashObjectMd5 } from '../../lib/hash-object-md5';

export const documentRequestObj=(sliceState)=>{
  const data=OCDocumentFactory(sliceState);
  const md5=hashObjectMd5(sliceState)
  return{data,md5}
}

